// extracted by mini-css-extract-plugin
var _1 = "ExtensionSearchBar-module__clearButton--PbO2E";
var _2 = "ExtensionSearchBar-module__clearButtonContainer--TJh6j";
var _3 = "ExtensionSearchBar-module__container--Tzjxm";
var _4 = "ExtensionSearchBar-module__icon--CYaDw";
var _5 = "ExtensionSearchBar-module__stuck--iJLFZ";
export { _1 as "clearButton", _2 as "clearButtonContainer", _3 as "container", _4 as "icon", _5 as "stuck" }
